import { useState } from "react"
import { DropdownBookingType, DropdownMonthList, DropdownPaymentType, DropdownYearList } from "utils/Constant"
import { MainBodyCard } from "components/Cards/MainBodyCard";
import { PagesTitle } from "components/Cards/PagesTitle";
import { FormCard } from "components/Cards/FormCard";
import DatePicker from "components/Input/DatePicker";
import Select from "react-select";
import PrintButton from "components/Button/PrintButton";
import { ReportsService } from "services/ReportsService";
import { DetailPaymentReportService } from "reportServices/DetailPaymentReportService";
import moment from "moment";

export default function DetailPaymentReport(){
    const { fetchDetailPaymentReport } = ReportsService()
    
    // PARAMETER
    const [selectedFilter, setSelectedFilter] = useState('1')
    const [selectedPeriodeMonth, setSelectedPeriodeMonth] = useState(moment(new Date()).format('M'))
    const [selectedPeriodeYear, setSelectedPeriodeYear] = useState(moment(new Date()).format('YYYY'))
    const [dateFrom, setDateFrom] = useState(new Date())
    const [dateTo, setDateTo] = useState(new Date())
    const [bookingType, setBookingType] = useState('')
    const [paymentType, setPaymentType] = useState('')

    // OPTIONS
    const filterOptions = [
        { label: 'Payment Date', value: '1' },
        { label: 'Payment Periode', value: '2' },
    ]
    const periodeMonthOptions = [
        ...DropdownMonthList
    ]
    const periodeYearOptions = [
        ...DropdownYearList
    ]
    const bookingTypeOptions = [
        { label: 'All', value: '' },
        ...DropdownBookingType,
    ]
    const paymentTypeOptions = [
        ...DropdownPaymentType,
    ]

    // BUTTON EVENT
    const printBtnClick = async () => {
        const res = await fetchDetailPaymentReport(
            selectedFilter,
            selectedPeriodeMonth,
            selectedPeriodeYear,
            moment(dateFrom).format('YYYY-MM-DD'), 
            moment(dateTo).format('YYYY-MM-DD'), 
            bookingType,
            paymentType
        )
        if (!res) return

        const data = res.data

        DetailPaymentReportService(selectedFilter, selectedPeriodeMonth, selectedPeriodeYear, data, dateFrom, dateTo, bookingType, paymentType)
    }

    return(
        <MainBodyCard className="flex flex-col gap-2">
            <PagesTitle title='Detail Payment Report' />

            <div className="mt-4 flex flex-col gap-4">
                <FormCard title='Filter By'>
                    <Select className="bg-white w-full h-10" options={filterOptions} value={filterOptions.find(x => x.value === selectedFilter)} onChange={(e) => setSelectedFilter(e.value)} placeholder='All' />
                </FormCard>

                {selectedFilter === '1' && (
                    <div className="flex flex-col gap-4">
                        <FormCard title='Date From'>
                            <DatePicker className="bg-white w-full h-10" value={dateFrom} onChange={(e) => setDateFrom(e)} />
                        </FormCard>

                        <FormCard title='Date To'>
                            <DatePicker className="bg-white w-full h-10" value={dateTo} onChange={(e) => setDateTo(e)} />
                        </FormCard>
                    </div>
                )}
                
                {selectedFilter === '2' && (
                    <FormCard title='Periode'>
                        <div className="flex gap-3">
                            <Select className="bg-white w-full h-10" options={periodeMonthOptions} value={periodeMonthOptions.find(x => x.value === selectedPeriodeMonth)} onChange={(e) => setSelectedPeriodeMonth(e.value)} placeholder='All' />
                            <Select className="bg-white w-full h-10" options={periodeYearOptions} value={periodeYearOptions.find(x => x.value === selectedPeriodeYear)} onChange={(e) => setSelectedPeriodeYear(e.value)} placeholder='All' />
                        </div>
                    </FormCard>
                )}

                <FormCard title='Booking Type'>
                    <Select className="bg-white w-full h-10" options={bookingTypeOptions} value={bookingTypeOptions.find(x => x.value === bookingType)} onChange={(e) => setBookingType(e.value)} placeholder='All' />
                </FormCard>

                <FormCard title='Payment Type'>
                    <Select className="bg-white w-full h-10" options={paymentTypeOptions} value={paymentTypeOptions.find(x => x.value === paymentType)} onChange={(e) => setPaymentType(e.value)} placeholder='All' />
                </FormCard>

                <FormCard title=''>
                    <div className="flex justify-end">
                        <PrintButton onClick={printBtnClick} />
                    </div>
                </FormCard>
            </div>
        </MainBodyCard>
    )
}